
export const FormSuccess = () => {
    document.title = "youngStartup Ventures | FormSuccess";

    return (
        <div style={{ textAlign: 'center', padding: '4em 2em', minHeight: '400px' }}>
            <h1 style={{ fontSize: '2em', padding: '2em 0' }}>Thank you for your submission!</h1>
            <a className="btn" href="http://youngstartup.com/upcoming">Upcoming Event</a>
        </div>
    );
};
